var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h4',[_vm._v(_vm._s(_vm.statistic))]),(_vm.loaded)?_c('Line-Chart',{attrs:{"chart-data":_vm.chartData}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }